import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
  selector: 'app-keyword-edit-dialog',
  templateUrl: './keyword-edit-dialog.component.html',
  styleUrls: ['./keyword-edit-dialog.component.css']
})
export class KeywordEditDialogComponent implements OnInit {
  id = null;
  oldName = null;
  keyword = new FormGroup({
    name: new FormControl()
  });
  constructor(public dialogRef: MatDialogRef<KeywordEditDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.keyword) {
      this.id = data.keyword.id;
      this.keyword.patchValue(data.keyword);
      this.oldName = data.keyword.name;
    }
  }

  ngOnInit() {
  }

  public closeDialog (): void {
    this.dialogRef.close();
  }

  public submitDialog (remove): void {
    if  (remove) {
      this.dialogRef.close({delete: true, id: this.id});
    } else {
      const result = this.keyword.value;
      if (this.id) {
        result.id = this.id;
      }
      this.dialogRef.close(result);
    }
  }

  isValid() {
    return this.keyword.get('name').value;
  }

}
